import { render, staticRenderFns } from "./Scene2.vue?vue&type=template&id=a7cf810c&"
import script from "./Scene2.vue?vue&type=script&lang=js&"
export * from "./Scene2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports